import(/* webpackMode: "eager" */ "/home/shehin/test/karetrip-blog/app/[slug]/components/TableofContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/shehin/test/karetrip-blog/app/home/components/blogCard/SocialShare.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/shehin/test/karetrip-blog/components/AuthorHoverContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/shehin/test/karetrip-blog/components/DelayedFormPopup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/shehin/test/karetrip-blog/components/FactCheckHoverContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/shehin/test/karetrip-blog/components/FaqSection.tsx");
;
import(/* webpackMode: "eager" */ "/home/shehin/test/karetrip-blog/components/GenericForm.tsx");
;
import(/* webpackMode: "eager" */ "/home/shehin/test/karetrip-blog/components/Markdown/mdx-components.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/shehin/test/karetrip-blog/components/MedVerifiedByContainer.tsx");
;
import(/* webpackMode: "eager" */ "/home/shehin/test/karetrip-blog/components/RelatedArticleWithSlider.tsx");
;
import(/* webpackMode: "eager" */ "/home/shehin/test/karetrip-blog/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/shehin/test/karetrip-blog/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/shehin/test/karetrip-blog/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/shehin/test/karetrip-blog/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/home/shehin/test/karetrip-blog/public/BlogDetails/ad@3x copy.webp");
;
import(/* webpackMode: "eager" */ "/home/shehin/test/karetrip-blog/public/BlogDetails/ad@3x.webp");
;
import(/* webpackMode: "eager" */ "/home/shehin/test/karetrip-blog/public/BlogDetails/Check.svg");
;
import(/* webpackMode: "eager" */ "/home/shehin/test/karetrip-blog/public/BlogDetails/tick@2x.png");
;
import(/* webpackMode: "eager" */ "/home/shehin/test/karetrip-blog/public/formpopup/consultationImg.webp");
;
import(/* webpackMode: "eager" */ "/home/shehin/test/karetrip-blog/public/homePage/FeatureImage.webp");
